import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout/Layout';
import { useAuth } from '../contexts/AuthContext';

const ProductDetailsPage = () => {
  const { productId } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getToken } = useAuth();

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const token = getToken();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/product-details/${productId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setProductDetails(response.data);
      } catch (err) {
        setError('خطا در دریافت اطلاعات محصول');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [productId, getToken]);

  if (loading) return <Layout><div className="text-center mt-8">در حال بارگذاری...</div></Layout>;
  if (error) return <Layout><div className="text-center mt-8 text-red-500">{error}</div></Layout>;
  if (!productDetails) return <Layout><div className="text-center mt-8">محصول یافت نشد</div></Layout>;

  return (
    <Layout>
      <div className="container mx-auto p-4">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="md:flex">
            <div className="md:flex-shrink-0">
              <img className="h-48 w-full object-cover md:w-48" src={productDetails.image_url} alt={productDetails.name1} />
            </div>
            <div className="p-8">
              <div className="uppercase tracking-wide text-sm text-indigo-500 font-semibold">{productDetails.name2}</div>
              <h1 className="block mt-1 text-lg leading-tight font-medium text-black">{productDetails.name1}</h1>
              <p className="mt-2 text-gray-500">{productDetails.price_text}</p>
            </div>
          </div>
          
          <div className="p-8 border-t border-gray-200">
            <h2 className="text-xl font-semibold mb-4">فروشندگان</h2>
            {productDetails.products_info.result.map((seller, index) => (
              <div key={index} className="mb-4 p-4 border rounded">
                <h3 className="font-semibold">{seller.shop_name}</h3>
                <p>{seller.price_text}</p>
                <p className="text-sm text-gray-500">{seller.shop_name2}</p>
                <a 
                  href={seller.page_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mt-2 inline-block bg-blue-500 text-white px-4 py-2 rounded"
                >
                  خرید از این فروشنده
                </a>
              </div>
            ))}
          </div>
          
          {productDetails.structural_specs.headers.length > 0 && (
            <div className="p-8 border-t border-gray-200">
              <h2 className="text-xl font-semibold mb-4">مشخصات محصول</h2>
              {productDetails.structural_specs.headers.map((header, index) => (
                <div key={index} className="mb-4">
                  <h3 className="font-semibold">{header.header}</h3>
                  <ul className="list-disc list-inside">
                    {Object.entries(header.specs).map(([key, value]) => (
                      <li key={key}>{key}: {value}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ProductDetailsPage;